<template>
    <span class="draggable-icon-wrapper"></span>
</template>

<script>
import OrganizationDeviceTree from '@/models/OrganizationDeviceTree'

export default {
    name: 'TreeViewItemOrganization',
    props: {
        value: {
            type: OrganizationDeviceTree
        }
    }
}
</script>

<style scoped lang="scss">
.draggable-icon {
    &--small {
        background-color: $secondary-default;
        padding: 5px;
        height: 20px;
        width: 20px;
        border-radius: 7px;

        @media (min-width: 1200px) {
            height: 23px;
            width: 29px;
        }
    }

    &--next {
        margin-left: 4%;
    }
}

.draggable-fleet-counter {
    font-size: 12px;
    font-weight: 700;
    margin-left: 1px;

    @media (min-width: 1200px) {
        margin-left: 5px
    }
}

.isMenuActive .tree {
    @media (min-width: 1200px) {
        .draggable-icon {
            &--small {
                height: 18px;
                width: 18px;
            }
        }
        .draggable-fleet-counter {
            margin-left: 1px;
        }
    }
    @media (min-width: 1440px) {
        .draggable-icon {
            &--small {
                height: 20px;
                width: 20px;
            }
        }
    }
    @media (min-width: 1700px) {
        .draggable-icon {
            &--small {
                height: 23px;
                width: 29px;
            }
        }
        .draggable-fleet-counter {
            margin-left: 3px;
        }
    }
}
</style>
